/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import {
  EditingState,
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
  SearchState,
  IntegratedFiltering,
  PagingState,
  IntegratedPaging,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  TableEditColumn,
  Toolbar,
  SearchPanel,
  DragDropProvider,
  Table,
  TableColumnReordering,
  TableColumnResizing,
  TableColumnVisibility,
  ColumnChooser,
  PagingPanel,
} from '@devexpress/dx-react-grid-material-ui';
import { Command, PopupEditing } from '../../Shared';
import {
  downloadCSVFile,
  getRowId,
  updateDocNumbers,
  userroles,
} from '../../common';
import {
  getVacations,
  getProducts,
  createVacation,
  updateVacation,
  deleteVacation,
} from '../../graphql';
import { useLazyQuery, useMutation } from '@apollo/client';
import {
  currencyFormatterEmpty,
  timeFormatter,
  userFormatter,
} from '../../Shared/colorFormat';
import { SearchTable } from '../../components';
import { getColumns } from '../../common/columns';
import { Box, Typography } from '@material-ui/core';
import useEmployees from '../../hooks/useEmployees';
import { useTemplate, useUsers } from '../../hooks';
import { getTasks } from '../../graphql/query';
import ExportBtn from '../../common/ExportBtn';
import AutoFieldLocal from '../../components/fields/AutoFieldLocal';
import { TableComponent } from '../components/TableComponent';
import PopupVacation from '../../pubups/PopupVacation';
import HRContext from '../../contexts/hr';

const Vacations = forwardRef((props: any, ref: any) => {
  const { isRTL, words, start, end, theme, company } = props;

  const col = getColumns({ isRTL, words });
  const { tempoptions } = useTemplate();

  const [columns] = useState(
    [
      { name: 'time', title: words?.time },
      col.employee,
      { name: 'isWorking', title: isRTL ? 'حاضر' : 'Present' },
      { name: 'isAbsent', title: isRTL ? 'غائب' : 'Absent' },
      { name: 'overtime', title: isRTL ? 'اضافي' : 'Overtime' },
      { name: 'bonos', title: isRTL ? 'مكافئة' : 'Bonos' },
      { name: 'deduction', title: isRTL ? 'خصم' : 'Deduction' },
      { name: 'desc', title: words?.notes },
      col.userId,
    ].filter((x) => x)
  );

  const [tableColumnExtensions]: any = useState([
    { columnName: 'time', width: 100 },
    { columnName: col.employee.name, width: 200 },
    { columnName: 'isWorking', width: 100 },
    { columnName: 'isAbsent', width: 100 },
    { columnName: 'overtime', width: 120 },
    { columnName: 'bonos', width: 120 },
    { columnName: 'deduction', width: 120 },
    { columnName: 'desc', width: 200 },
    { columnName: 'userId', width: 150 },
  ]);

  const [rows, setRows] = useState([]);
  const [emplvalue, setEmplvalue] = useState<any>(null);

  const { activeemployees: employees } = useEmployees();
  const { users } = useUsers();

  const {
    state: { hiddenColumnNames },
    dispatch,
  } = useContext(HRContext);

  const setHiddenColumnNames = (hiddenColumns: any) => {
    dispatch({ type: 'setHiddenColumnNames', payload: hiddenColumns });
  };

  const [loadVacations, opData]: any = useLazyQuery(getVacations, {
    fetchPolicy: 'cache-and-network',
  });

  const refresQuery = {
    refetchQueries: [
      {
        query: getVacations,
        variables: {
          start: start ? start.setHours(0, 0, 0, 0) : undefined,
          end: end ? end.setHours(23, 59, 59, 999) : undefined,
          employeeId: emplvalue ? emplvalue?._id : undefined,
        },
      },
      { query: getProducts },
      { query: getTasks },
    ],
  };

  useEffect(() => {
    const variables = {
      start: start ? start.setHours(0, 0, 0, 0) : undefined,
      end: end ? end.setHours(23, 59, 59, 999) : undefined,
      employeeId: emplvalue ? emplvalue?._id : undefined,
    };
    if (start && end) {
      loadVacations({
        variables,
      });
    }
  }, [start, end, emplvalue]);

  const [addVacation] = useMutation(createVacation, refresQuery);
  const [editVacation] = useMutation(updateVacation, refresQuery);
  const [removeVacation] = useMutation(deleteVacation, refresQuery);

  useImperativeHandle(ref, () => ({
    refresh() {
      if (opData?.refetch) {
        opData.refetch();
      }
    },
  }));

  const commitChanges = async ({ deleted }) => {
    if (deleted) {
      const _id = deleted[0];
      removeVacation({ variables: { _id } });
      setRows(rows.filter((row: any) => row._id !== _id));
    }
  };
  useEffect(() => {
    if (opData?.data?.getVacations?.data) {
      const { data } = opData.data.getVacations;
      const rdata = updateDocNumbers(data);
      setRows(rdata);
    }
  }, [opData]);

  const downloadCSVSubmit = () => {
    const colnames = columns?.map((col: any) => col?.name);
    downloadCSVFile(rows, 'invoices', colnames);
  };

  return (
    <>
      <Box
        style={{
          position: 'absolute',
          top: 8,
          left: isRTL ? 400 : undefined,
          right: isRTL ? undefined : 400,
          display: 'flex',
        }}
      >
        <ExportBtn open={downloadCSVSubmit} isRTL={isRTL}></ExportBtn>
      </Box>
      <Box
        display="flex"
        style={{
          position: 'absolute',
          top: 55,
          left: isRTL ? 330 : undefined,
          right: isRTL ? undefined : 350,
          display: 'flex',
          flexGrow: 1,
          zIndex: 111,
        }}
      >
        <Box display={'flex'}>
          <AutoFieldLocal
            name="employee"
            title={words?.employee}
            words={words}
            options={employees}
            value={emplvalue}
            setSelectValue={setEmplvalue}
            isRTL={isRTL}
            width={300}
            mb={0}
          ></AutoFieldLocal>
        </Box>
      </Box>
      <Grid rows={rows} columns={columns} getRowId={getRowId}>
        <SortingState />
        <EditingState onCommitChanges={commitChanges} />
        <SearchState />
        <PagingState defaultCurrentPage={0} defaultPageSize={10} />
        <IntegratedSorting />
        <IntegratedFiltering />
        <IntegratedPaging />
        <DragDropProvider />
        <Table
          messages={{
            noData: isRTL ? 'لا يوجد بيانات' : 'no data',
          }}
          tableComponent={TableComponent}
          rowComponent={(props: any) => (
            <Table.Row {...props} style={{ height: 60 }}></Table.Row>
          )}
          columnExtensions={tableColumnExtensions}
        />

        <TableColumnReordering
          defaultOrder={[
            'time',
            col.employee.name,
            'isWorking',
            'isAbsent',
            'overtime',
            'bonos',
            'deduction',
            'desc',
            'userId',
          ]}
        />
        <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />

        <TableHeaderRow
          showSortingControls
          titleComponent={({ children }) => {
            return (
              <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                {children}
              </Typography>
            );
          }}
        />
        <TableColumnVisibility
          defaultHiddenColumnNames={hiddenColumnNames}
          hiddenColumnNames={hiddenColumnNames}
          onHiddenColumnNamesChange={setHiddenColumnNames}
        />
        <DataTypeProvider
          for={['time']}
          formatterComponent={timeFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['userId']}
          formatterComponent={(props: any) =>
            userFormatter({ ...props, users })
          }
        ></DataTypeProvider>
        <DataTypeProvider
          for={['overtime', 'bonos', 'deduction']}
          formatterComponent={currencyFormatterEmpty}
        ></DataTypeProvider>
        <TableEditColumn
          showEditCommand={userroles?.sales?.edit}
          showDeleteCommand={!userroles?.isEmployee && userroles?.sales?.delete}
          showAddCommand={userroles?.sales?.add}
          commandComponent={Command}
        ></TableEditColumn>

        <Toolbar
          rootComponent={(props: any) => (
            <Toolbar.Root
              style={{
                position: 'absolute',
                left: isRTL ? 40 : undefined,
                right: isRTL ? undefined : 40,
                top: 62,
                zIndex: 115,
              }}
              {...props}
            ></Toolbar.Root>
          )}
        />
        <ColumnChooser />
        <PagingPanel
          pageSizes={
            tempoptions?.pageall ? [5, 10, 20, 50, 0] : [5, 10, 20, 50]
          }
        />

        <SearchPanel
          inputComponent={(props: any) => {
            return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
          }}
        />
        <PopupEditing addAction={addVacation} editAction={editVacation}>
          <PopupVacation
            words={words}
            company={company}
            theme={theme}
          ></PopupVacation>
        </PopupEditing>
      </Grid>
    </>
  );
});

export default Vacations;
